<div class="frequency-select-container d-flex flex-col">
    <div class="d-flex items-baseline">
        <div>
            <h3 class="form-field-title label-style">{{ props?.label }}<span *ngIf="props?.required">*</span></h3>
        </div>
        <div class="button-container d-flex flex-gap-1">
            <button *ngIf="defaultFrequencyButton === 'cron'" mat-button
                (click)="displaySubField.props.showGenerateExpressionFields = true" class="generateBtn">Generate Cron
                Expression</button>
            <mat-button-toggle-group appearance="legacy" class="frequency-select-toggle" name="fontStyle"
                aria-label="Font Style" [(ngModel)]="defaultFrequencyButton" (change)="frequencyChangeHandler($event)">
                <mat-button-toggle class="frequency-select-group-btn" *ngFor="let item of displayFrequencyTypes"
                    [value]="item.value">{{item.displayName}}</mat-button-toggle>
            </mat-button-toggle-group>
        </div>
    </div>
    <ng-container *ngIf="displaySubField">
        <div class="d-flex">
            <formly-field [field]="displaySubField"></formly-field>
        </div>
    </ng-container>
    <mat-hint [innerHtml]="props?.description"></mat-hint>
</div>